import {Component,Inject} from "@angular/core";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {IconNatureVoyage} from "@domain/prestation/nature-voyage";

/**
 * Composant d'affichage des icônes disponibles pour les types de charges
 */
@Component({
    host: {'data-test-id': 'factures-types-charges-infos-icones'},
    templateUrl: './factures-types-charges-infos-icones.component.html'
})
export class FacturesTypesChargesInfosIconesComponent {
    /** Liste des icônes disponibles pour les types de charges */
    listeIcones = ['flight_takeoff', 'train', 'directions_car', 'hotel', 'language', 'euro'];

    /**
     * Constructeur
     *
     * @param dialogRef Référence vers la boîte de dialogue du composant
     * @param data Données passées en paramètre
     */
    constructor(public dialogRef: MatDialogRef<FacturesTypesChargesInfosIconesComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {codeFamille: string}) {
    }

    /**
     * Méthode appelée lors de la sélection d'une icône
     *
     * @param icone Icône sélectionnée
     */
    onSelect(icone) {
        //Fermeture de la boîte de dialogue et envoi de l'icône sélectionnée au composant parent
        this.dialogRef.close(IconNatureVoyage[icone] || "");
    }
}
